import { render, staticRenderFns } from "./WordSeparatorListTable.vue?vue&type=template&id=798cdcaa&scoped=true&lang=html"
import script from "./WordSeparatorListTable.vue?vue&type=script&lang=js"
export * from "./WordSeparatorListTable.vue?vue&type=script&lang=js"
import style0 from "./WordSeparatorListTable.vue?vue&type=style&index=0&id=798cdcaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798cdcaa",
  null
  
)

export default component.exports